<template>
  <div class="card">
    <div class="card-header" style="display: flex; justify-content: space-between;">
      <h4>Chi tiết tác vụ</h4>
      <el-button
          type="primary" v-if="taskDetail.showMark"
          class="text-white" @click="redirectToMarkExam">
        <i class="el-icon-edit-outline text-white mr-2"></i>
        Chấm bài
      </el-button>
      <el-button
          type="warning" v-if="taskDetail.showHandleCheating"
          class="text-white" @click="isCheating = true">
        <i class="el-icon-edit-outline text-white mr-2"></i>
        Xử lý gian lận
      </el-button>
      <router-link
          v-if="taskDetail.statusLabel === 'Hoàn thành'"
          :to="viewExamRoute"
          class="btn"
      >
        <i class="el-icon-view mr-1 text-white"></i>
        Xem lại
      </router-link>

    </div>
    <div class="card-body display-card__grid" v-loading="loading">
      <TaskDetailInfo :task-detail="taskDetail"/>
      <ResultTestEntrance v-if="taskDetail.isEntrance" :marking-exam-retake-id="markingRetakeId"/>
      <ResultTest v-else :task-detail="taskDetail"/>
    </div>
    <el-dialog
        title="Xác nhận xử lý gian lận"
        :show-close="false"
        :visible.sync="isCheating"
        v-if="isCheating" width="40%"
    >
      <hr style="padding: 0; margin-top: -20px"/>
      <p style="word-break: break-word">Khi chọn gian lận, hệ thống sẽ tự động kĩ năng là
        <span style="color: red; font-weight: 600">0 điểm</span> và kết thúc tác vụ này.
      </p>
      <p style="word-break: break-word">Khi chọn không gian lận, hệ thống sẽ ghi nhận điểm cho học viên theo kết quả của
        admin chấm.</p>
      <div style="display: flex; flex-direction: column; gap: 8px">
        <span style="font-weight: 600; word-break: break-word">Vui lòng nhập kết quả xử lý gian lận cho học viên:</span>
        <el-radio-group v-model="cheatingValue">
          <el-radio :label="1">Gian lận</el-radio>
          <el-radio :label="2">Không gian lận</el-radio>
        </el-radio-group>
      </div>
      <div style="display: flex; width: 100%; justify-content: end; margin-top: 10px">
        <el-button @click="closeDialog">Hủy bỏ</el-button>
        <el-button
            :disabled="cheatingValue === null"
            style="background: #5E00B6; color: white;"
            type="primary" @click="handleCheatingTask"
        >
          Xác nhận
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {GET_DETAIL_TASK, HANDLE_CHEATING_TASK} from "@/core/services/store/examSchedule/examSchedule";
import {TaskDetailModel} from "@/view/pages/manage-exam-schedule/model/TaskModel";
import TaskDetailInfo from "@/view/pages/manage-exam-schedule/component/TaskInfo.vue";
import ResultTest from "@/view/pages/manage-exam-schedule/component/ResultTest.vue";
import ResultTestEntrance from "@/view/pages/manage-exam-schedule/component/ResultTestEntrance.vue";
import {SET_BREADCRUMB} from "@/core/services/store/breadcrumbs.module";

export default {
  name: 'TaskManageDetail',
  components: {ResultTest, ResultTestEntrance, TaskDetailInfo},
  data() {
    return {
      taskDetail: {},
      loading: false,
      isCheating: false,
      cheatingValue: null,
      loadingCheating: false,
      markingRetakeId: this.$route.query.marking_exam_retake_id,
      isMidterm: this.$route.query.is_midTerm,
      classroomId: this.$route.query.classroom_id,
    }
  },
  methods: {
    closeDialog() {
      this.isCheating = false
      this.cheatingValue = null
    },
    getDetailTask() {
      this.loading = true
      this.$store.dispatch(GET_DETAIL_TASK, this.$route.params.taskId).then(res => {
        if (!res.error) {
          this.taskDetail = new TaskDetailModel(res?.data) ?? null
        }

      }).catch(e => {
        this.$message.error(e?.data?.message ?? 'Có lỗi xảy ra!')
      }).finally(() => this.loading = false)
    },
    redirectToMarkExam() {
      if (this.isMidtermBool) {
        this.$router.push({
          name: `mark-midterm-test`,
          query: {
            classId: this.$route.query.classroom_id,
            name: this.taskDetail?.customerName,
            academic_task_id: this.taskDetail?.taskCode
          },
          params: {id: this.$route.query.marking_exam_retake_id}
        })
        return
      }
      this.$router.push({
        name: 'MarkExamStudent',
        query: {
          marking_retake_id: this.$route.query.marking_exam_retake_id,
          type: this.taskDetail.type,
          academic_task_id: this.taskDetail.taskCode
        }
      })
    },
    handleCheatingTask() {
      this.loadingCheating = true
      const payload = {
        marking_exam_retake_id: this.$route.query.marking_exam_retake_id,
        is_cheating: +this.cheatingValue === 1,
      }
      this.$store.dispatch(HANDLE_CHEATING_TASK, payload).then(res => {
        if (!res.error) {
          this.$message.success('Xử lý tác vụ gian lận thành công!')
          this.$router.push({name: 'ManageTaskList'})
        }
      }).catch(e => {
        this.$message.error(e.data.message || 'Xử lý tác vụ gian lận thất bại!')
      }).finally(() => {
        this.loadingCheating = false
      })
    }
  },
  computed: {
    isMidtermBool() {
      return this.isMidterm === 'true' || this.isMidterm === true
    },
    viewExamRoute() {
      if (this.isMidtermBool) {
        return {
          name: 'view-midterm-test-result',
          params: { id: this.markingRetakeId },
          query: {
            classId: this.classroomId,
            name: this.taskDetail?.customerName
          }
        }
      }

      return {
        name: 'ViewExamStudent',
        query: {
          marking_retake_id: this.markingRetakeId,
          type: this.taskDetail.type,
          academic_task_id: this.taskDetail.taskCode
        }
      }
    }

  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      {title: "Quản lý tác vụ"},
      {title: "Chi tiết tác vụ", name: 'TaskManageDetail'},
    ]);
    this.getDetailTask()
  }
}
</script>

<style scoped>
.display-card__grid {
  display: grid;
  grid-template-columns: 1fr 2fr;
  gap: 20px;
}
.btn{
  background-color: #0C9200;
  color: white;
}
</style>
